import React, { useEffect, useState } from 'react'
import Modal from 'react-modal'
import { docModalStylesNew, optionsModalStylesNew } from '../utils/styles'
import closeIconModal from '../../assets/img/cross-modal-icon.png'
import closeModalArrow from '../../assets/img/close-opciones-arrow.svg'
const OpcionesOrdenamientoModal = ({
  displayModal,
  setDisplayModal,
  closeModal,
  distanceToTop,
  toFilter,
  setNroAvisoFilterValue,
  setFechaAvisoFilterValue,
  setPrioridadFilterValue,
  setProductoFilterValue,
  setDisplayOrdenarAvisosMantenimientoModal,
  isCobrosPorFormular = false,
  fechaOrdenFilterValue,
  setFechaOrdenFilterValue,
  nroOrdenFilterValue,
  setNroOrdenFilterValue,
  montoPlanFilterValue,
  setMontoPlanFilterValue,
  estadoFilterValue,
  setEstadoFilterValue,
}) => {

  const [optionsArray, setOptionsArray] = useState([])

  useEffect(() => {
    let alfabeticOrderOtions = [
      {label: "A - Z", value: "A_Z"},
      {label: "Z - A", value: "Z_A"},
    ]

    let dateOrderOptions = [
      {label: "Desde fecha más antigua", value: "ASC"},
      {label: "Desde fecha más reciente", value: "DESC"},
    ]

    let priorityOrderOptions = [
      {label: "Mayor a menor", value: "DESC"},
      {label: "Menor a mayor", value: "ASC"},
    ]

    if (toFilter === 'producto' || toFilter === 'prioridad' || toFilter === 'estado') {
      setOptionsArray(alfabeticOrderOtions)
    }

    if (toFilter === 'nro_aviso' || toFilter === 'nro_orden' || toFilter === 'monto_plan') {
      setOptionsArray(priorityOrderOptions)
    }

    if (toFilter === 'fecha_aviso' || toFilter === 'fecha_orden') {
      setOptionsArray(dateOrderOptions)
    }
  }, [toFilter]);

  const handleOptionClick = (option) => {
    switch (toFilter) {
      case 'nro_aviso':
        setNroAvisoFilterValue(option)
        break;
      case 'fecha_aviso':
        setFechaAvisoFilterValue(option)
        break;
      case 'prioridad':
        setPrioridadFilterValue(option)
        break;
      case 'producto':
        setProductoFilterValue(option)
        break;
      case 'nro_orden':
        setNroOrdenFilterValue(option)
        break;
      case 'fecha_orden':
        setFechaOrdenFilterValue(option)
        break;
      case 'estado':
        setEstadoFilterValue(option)
        break;
      case 'monto_plan':
        setMontoPlanFilterValue(option)
        break;
    }
    setDisplayOrdenarAvisosMantenimientoModal(true)
    setDisplayModal(false)
  }

  const getModalTitle = (titleOpt) => {
    switch (titleOpt) {
      case 'nro_aviso':
        return 'Nº de Aviso'
      case 'fecha_aviso':
        return 'Fecha de Aviso'
      case 'prioridad':
        return 'Prioridad'
      case 'producto':
        return 'Producto'
      case 'nro_orden':
        return 'Nº de Orden'
      case 'fecha_orden':
        return 'Fecha de Orden'
      case 'estado':
        return 'Estado'
      case 'monto_plan':
        return 'Monto Plan'
    }
  }

  const handleClickOButton = () => {
    setDisplayOrdenarAvisosMantenimientoModal(true)
    setDisplayModal(false)
  }


  return (
    <Modal
      isOpen={displayModal}
      onRequestClose={closeModal}
      style={optionsModalStylesNew(distanceToTop - 20)}
    >
      <div className="opciones-ordenamiento-modal-container">
        <div className="title-label-container">
          <div className="title">
            {getModalTitle(toFilter)}
          </div>
        </div>
        <div className="opciones-ordenamiento-modal-separator"></div>
        <div className="options-container">
          {optionsArray.map((option) => (
            <div className="option-title" key={option.value} onClick={() => handleOptionClick(option)}>{option.label}</div>
          ))}
        </div>
        <div className="opciones-ordenamiento-modal-separator semi"></div>
        <div className="button-container">
          <div className="button" onClick={handleClickOButton}>
            <img src={closeModalArrow} alt="arrow left" />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default OpcionesOrdenamientoModal;